import React from "react";
import styles from "./Button.module.css";

export function Button({
  className = "",
  variant,
  size = "default",
  children,
  ...props
}) {
  if (!variant && className) {
    return (
      <button type="button" className={className} {...props}>
        {children}
      </button>
    );
  }

  const resolvedVariant = variant || "primary";
  const variantClass = styles[resolvedVariant] || styles.primary;
  const sizeClass = styles[size] || styles.default;

  return (
    <button
      type="button"
      className={`${styles.button} ${variantClass} ${sizeClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
